import React from 'react'
import { useSinglePole } from '../../../../hooks'
import PoleNumberView from './PoleNumberView/PoleNumberView'

export default function PoleNumberPresenter() {
  const {singlePoleQuery:{data}} = useSinglePole()



  return (
    <PoleNumberView number={data?.pole_number}/>
  )
}
